module.exports = __webpack_public_path__ + "img/edit-button-new.d717a313.svg";